import { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';

// Lazy load the heavy Mapbox component
const InteractiveHotelMap = lazy(() => import('./InteractiveHotelMap'));

interface LazyInteractiveHotelMapProps {
  isOpen: boolean;
  onClose: () => void;
  hotelName: string;
  latitude: number;
  longitude: number;
}

const MapLoader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
    <div className="flex flex-col items-center gap-3">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <span className="text-sm text-muted-foreground">Cargando mapa...</span>
    </div>
  </div>
);

export const LazyInteractiveHotelMap = ({ isOpen, ...props }: LazyInteractiveHotelMapProps) => {
  // Only render the heavy component when the modal is open
  if (!isOpen) return null;
  
  return (
    <Suspense fallback={<MapLoader />}>
      <InteractiveHotelMap isOpen={isOpen} {...props} />
    </Suspense>
  );
};

export default LazyInteractiveHotelMap;
